import MoreVertIcon from "@mui/icons-material/MoreVert";
import { MRT_Cell } from "material-react-table";
import IwMenu from "../../../app/IwMenu";
import { TTeamUser } from "../../team/teamUserInfoTab/TeamUserTable";
import ExtendSeatModal from "../../common/ExtendSeat.modal";
import { useState } from "react";
import { DeleteSeatModal } from "../../common/DeleteSeat.modal";

export const OrgUsersLicenseActionCell = ({ cell }: { cell: MRT_Cell<TTeamUser, unknown> }) => {
  const [openExtendSeatModal, setOpenExtendSeatModal] = useState(false);
  const [openDeleteSeatModal, setOpenDeleteSeatModal] = useState(false);

  const tableData=cell?.row?.original;
  const isDisabled = tableData?.seatID === null || tableData?.userID === null;

  return (
    <>
      <ExtendSeatModal 
        open={openExtendSeatModal} 
        handleClose ={()=>setOpenExtendSeatModal(false)}
        tableData={tableData}
      />

      <DeleteSeatModal 
        open={openDeleteSeatModal} 
        handleClose ={()=>setOpenDeleteSeatModal(false)}
        tableData={tableData}
      />

      <IwMenu
        label={<MoreVertIcon fontSize="small" />}
        tooltipProps={{
          title: "Options"
        }}
        triggerComponentSx={{
          margin: "0 8px",
          padding: "2px 0"
        }}
        items={[
          {
            id: "extend-seat",
            label: "Extend Seat",
            onClick: () => {
              setOpenExtendSeatModal(true);
            },
            disabled:isDisabled
          },
          {
            id: "delete",
            label: "Delete",
            onClick: () => { 
              setOpenDeleteSeatModal(true);
            },
            disabled:isDisabled
          },
        ]}
      />
    </>
  );
};
